module.exports = __webpack_public_path__ + "img/df7b443.png";